import { render, staticRenderFns } from "./rate-white-list.vue?vue&type=template&id=59f4a658&scoped=true"
import script from "./rate-white-list.vue?vue&type=script&lang=js"
export * from "./rate-white-list.vue?vue&type=script&lang=js"
import style0 from "./rate-white-list.vue?vue&type=style&index=0&id=59f4a658&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4a658",
  null
  
)

export default component.exports